import { createIconComponent } from '../../factory/create-icon-component';
export const IsraelIcon = createIconComponent(
  'IsraelIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33627)">
      <path d="M23 5H1V20H23V5Z" fill="#F0F0F0" />
      <path
        d="M14.75 10.8761H12.9167L12 9.25226L11.0833 10.876H9.25L10.1667 12.4998L9.25 14.1235H11.0833L12 15.7473L12.9167 14.1236H14.75L13.8333 12.4998L14.75 10.8761ZM13.1262 12.4998L12.5631 13.4973H11.4369L10.8738 12.4998L11.4369 11.5023H12.5631L13.1262 12.4998ZM12 10.5048L12.2096 10.8761H11.7904L12 10.5048ZM10.3107 11.5023H10.7298L10.5203 11.8735L10.3107 11.5023ZM10.3107 13.4973L10.5202 13.1261L10.7298 13.4973H10.3107ZM12 14.4948L11.7905 14.1235H12.2096L12 14.4948ZM13.6893 13.4973H13.2702L13.4797 13.1261L13.6893 13.4973ZM13.2702 11.5023H13.6893L13.4798 11.8735L13.2702 11.5023Z"
        fill="#2E52B2"
      />
      <path d="M23 5.93713H1V7.81195H23V5.93713Z" fill="#2E52B2" />
      <path d="M23 17.187H1V19.0618H23V17.187Z" fill="#2E52B2" />
    </g>
    <defs>
      <clipPath id="clip0_10086_33627">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
